import { n$2, e$2 } from '@/js/global/global';

const {
  strings: {
    accessibility: strings$7
  }
} = window.theme;
const handleTab = () => {
  let tabHandler = null;
  const formElments = ["INPUT", "TEXTAREA", "SELECT"];
  // Determine if the user is a mouse or keyboard user
  function handleFirstTab(e) {
    if (e.keyCode === 9 && !formElments.includes(document.activeElement.tagName)) {
      document.body.classList.add("user-is-tabbing");
      tabHandler();
      tabHandler = e$2(window, "mousedown", handleMouseDownOnce);
    }
  }
  function handleMouseDownOnce() {
    document.body.classList.remove("user-is-tabbing");
    tabHandler();
    tabHandler = e$2(window, "keydown", handleFirstTab);
  }
  tabHandler = e$2(window, "keydown", handleFirstTab);
};
const focusFormStatus = node => {
  const formStatus = n$2(".form-status", node);
  if (!formStatus) return;
  const focusElement = n$2("[data-form-status]", formStatus);
  if (!focusElement) return;
  focusElement.focus();
};
const prefersReducedMotion = () => {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};
function backgroundVideoHandler(container) {
  const pause = n$2(".video-pause", container);
  const pauseIcon = pause.getElementsByClassName('icon-pause')[0];
  const playIcon = pause.getElementsByClassName('icon-play')[0];
  const video = container.getElementsByTagName("VIDEO")[0];
  const a11yText = n$2('.screen-reader-text', pause);

  if (!pause || !video) return;
  const pauseVideo = () => {
    video.pause();

    playIcon.style.display = 'block';
    pauseIcon.style.display = 'none';

    a11yText.innerText = strings$7.play_video;
  };

  const playVideo = () => {
    video.play();

    playIcon.style.display = 'none';
    pauseIcon.style.display = 'block';

    a11yText.innerText = strings$7.pause_video;
  };

  if (prefersReducedMotion()) {
    pauseVideo();
  }

  const pauseListener = e$2(pause, "click", e => {
    e.preventDefault();

    if (video.paused) {
      playVideo();
    } else {
      pauseVideo();
    }
  });

  return () => pauseListener();
}

export { handleTab, focusFormStatus, prefersReducedMotion, backgroundVideoHandler }